var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.errors, function (error) {
      return _c("p", { key: error, staticClass: "py-1 text-red-500" }, [
        _vm._v(" " + _vm._s(error) + " "),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }